import { setAuthorization, TokenManager } from "helpers/api_helper";
import { postAdminLogin } from "../../../helpers/backend_helper";

import {
  loginRequest,
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
} from "./reducer";

export const loginUser = (user: any, history: any, rememberMe: boolean = false) => async (dispatch: any) => {
  dispatch(loginRequest());

  try {
    const response = await postAdminLogin({
      email: user.email,
      password: user.password,
    });

    // Gateway wraps user-service response: { success, message, data: { token, refresh_token, admin, ... } }
    const payload = response?.data ?? response;
    const token = payload?.token;

    if (token) {
      const tokenPayload = { ...payload, user_type: "admin" };
      TokenManager.setTokens(tokenPayload, rememberMe);
      setAuthorization(token);
      dispatch(loginSuccess(tokenPayload));
      history("/dashboard");
      return { success: true, ...payload };
    }

    const errorMessage = response?.message || response?.error || payload?.error || "Login failed";
    dispatch(apiError({ data: errorMessage }));
    return { success: false, message: errorMessage };
  } catch (error: any) {
    // API rejects with response.data directly (see api_helper interceptor)
    const errorResponse = error?.response?.data || {
      success: false,
      message: error?.error || error?.message || "An error occurred during login. Please try again.",
    };
    dispatch(apiError({ data: errorResponse.message || errorResponse.error }));
    return { success: false, ...errorResponse };
  }
};

// Affiliate login is not available in the admin app; kept as a stub so
// legacy template pages still compile.
export const loginAffiliateUser = (_user: any, _history: any, _rememberMe: boolean = false) => async (dispatch: any) => {
  const message = "Affiliate login is not available in the admin portal.";
  dispatch(apiError({ data: message }));
  return { success: false, message };
};

export const logoutUser = () => async (dispatch: any) => {
  try {
    TokenManager.clearTokens();
    dispatch(logoutUserSuccess(true));
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};
